// @flow

import React from 'react';
import NavigateLink from 'app/common/react/ui/NavigateLink';
import { Box, Text } from 'gestalt';

type Props = {|
  link?: string,
  title?: string,
|};

export default function AttributionTitle({ link, title }: Props) {
  if (!title) {
    return null;
  }

  const text = (
    <Text leading="short" size="sm" truncate>
      {title}
    </Text>
  );

  return (
    <Box>
      {link ? (
        <NavigateLink className="underlineLink" to={link}>
          {text}
        </NavigateLink>
      ) : (
        text
      )}
    </Box>
  );
}
